import React from 'react';
import { FormRenderProps } from '@progress/kendo-react-form';
import { ContentTypeFieldResponse } from '../../../../Model/responseDtos/ContentTypeFieldResponse';

interface FormFieldsSectionProps {
  ungroupedFields: ContentTypeFieldResponse[];
  groupedFields: Map<string, ContentTypeFieldResponse[]>;
  renderField: (ctField: ContentTypeFieldResponse, formRenderProps: FormRenderProps) => React.ReactNode;
  formRenderProps: FormRenderProps;
}

export const FormFieldsSection: React.FC<FormFieldsSectionProps> = ({
  ungroupedFields,
  groupedFields,
  renderField,
  formRenderProps
}) => {
  return (
    <div className="gearForm">
      {ungroupedFields.map(ctField => renderField(ctField, formRenderProps))}

      {Array.from(groupedFields.entries()).map(([groupName, fields]) => (
        <div key={groupName} className="gearFormGroup">
          <div className="gearFormGroupHeader">
            <h3 className="gearFormGroupTitle">{groupName}</h3>
          </div>
          <div className="gearFormGroupFields">{fields.map(ctField => renderField(ctField, formRenderProps))}</div>
        </div>
      ))}
    </div>
  );
};
